module.exports = __webpack_public_path__ + "img/KN-SK.ad31bfd5.svg";